import React from 'react';
import PrimaryButton from '../common/PrimaryButton';
import { graphql, useStaticQuery } from 'gatsby';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import { TypewriterHeader } from '../../utils';
const Hero = () => {
    const data = useStaticQuery(query);

    const {
        allStrapiHomeHero: { nodes: HomeHero },
    } = data;

    const { home_hero_heading, home_hero_subheading, home_hero_button } =
        HomeHero[0];
    const newHeader = TypewriterHeader(home_hero_heading);
    console.log('home_hero_subheading', home_hero_heading);
    return (
        <>
            <section className="hero_main">
                <div className="hero_main_first">
                    <h1
                        key={`heading`}
                        dangerouslySetInnerHTML={{ __html: newHeader }}
                    />
                    <p
                        dangerouslySetInnerHTML={{
                            __html: home_hero_subheading,
                        }}
                    />
                    <AniLink fade to={home_hero_button.button_redirection}>
                        <PrimaryButton
                            ButtonText={home_hero_button.button_text}
                            MaxWidth={13.9375}
                        />
                    </AniLink>
                </div>
            </section>
        </>
    );
};

export const query = graphql`
    {
        allStrapiHomeHero {
            nodes {
                home_hero_heading
                home_hero_subheading
                home_hero_button {
                    button_redirection
                    button_text
                }
            }
        }
    }
`;

export default Hero;
